import { Banner } from "@/components/flexkit/Banner";
import { useGetAnnouncementBanner } from "@/queries/organization-queries";
import { AnnouncementMarkdown } from "@/components/AnnouncementMarkdown";
import { type FC } from "react";

export const MAX_BANNER_LINES = 3;

export const OrganizationAnnouncementBanner: FC = () => {
    const { data: banner, isLoading } = useGetAnnouncementBanner();

    if (isLoading) {
        return null;
    }

    if (!banner?.enabled || !banner?.message) {
        return null;
    }

    return (
        <Banner
            variant="announcement"
            data-testid="organization-announcement-banner"
            className="max-h-24 shrink-0 overflow-hidden duration-500 ease-out animate-in fade-in"
            text={
                <span className="line-clamp-3 pr-0.5 duration-700 ease-out animate-in fade-in slide-in-from-top-1">
                    <AnnouncementMarkdown content={banner.message} className="text-inherit" />
                </span>
            }
        />
    );
};
